import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Wraps react-router-dom's useNavigate for devenv view navigation.
 * Accepts view IDs (e.g. "swap", "pools") and navigates to `/${viewId}`.
 * Maps "overview" to "/" (root).
 */
export function useDevenvNavigate(): (viewId: string) => void {
  const navigate = useNavigate();
  return useCallback(
    (viewId: string) => {
      void navigate(viewId === "overview" ? "/" : `/${viewId}`);
    },
    [navigate],
  );
}
